import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import DEATH_API from "../../apis/death.api";
import { PermissionsSection } from "./component/PermissionSection";
import ProfileForm from "./component/ProfileForm";
import swal from "sweetalert";
import "./Profilepage.css";
import NewLoader from "../../components/styled-components/loader/NewLoader";

export const ProfilePageV2 = () => {
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showButtons, setShowButtons] = useState(false);
  const [formData2, setFormData2] = useState(null);
  const [editIconVisible, setEditIconVisible] = useState(true);
  const location = useLocation();

  const handlechange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
    setFormData2({
      ...formData2,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Submit...", formData2);
    try {
      let playload = {};
      playload = {
        name: formData && formData.name,
        userName: formData && formData.userName,
        email: formData && formData.email,
        phoneNumber: formData && formData.phoneNumber,
        zipCode: formData && +formData.zipCode,
        password: formData && formData.password,
        hideTransactions: formData && formData.hideTransactions
        
      };
      setLoading(true);
      console.log("obj in playload update", playload);
      const response = await DEATH_API.updateProfileData(playload);
      console.log("response", response);
      if (response.status === 200) {
        swal("Success", response.message, "success");
      }
      if (response.status === 400) {
        swal("Oops!", response.message, "error");
      }
      setLoading(false);
      setFormData(null);
      getProfileDetails();
    } catch (error) {
      console.log("error in update", error);
      setLoading(false);
    }
  };

  const getProfileDetails = async () => {
    try {
      setLoading(true);
      const data = await DEATH_API.getProfileData();
      setLoading(false);
      if (data && data.data) {
        data.data.phoneNumber = `${data.data.countryCode} ${data.data.phoneNumber}`;
        setFormData(data.data);
      }
      if (data && data.data) {
        localStorage.setItem("User", data.data.name);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (
      !(location.pathname === "Login") &&
      !(location.pathname === "Otp") &&
      !(location.pathname === "Logout") &&
      !(location.pathname === "Forget Password") &&
      !(location.pathname === "Confirm") &&
      !(location.pathname === "Signup") &&
      !(location.pathname === "TrusteeLogin") &&
      !(location.pathname === "Accept Invitation") &&
      !(location.pathname === "Payment")
    ) {
      console.log("dasdasdasd");
      getProfileDetails();
    }
  }, []);

  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const isTrustee =
    userRole && (userRole === "trustee" || userRole === "protrustee");

  return (
    <div style={{position:"relative"}}>
      <div className="profileMain" style={{ display: "flex" }}>
        <ProfileForm
          formData={formData}
          setEditIconVisible={setEditIconVisible}
          showPassword={showPassword}
          setShowPassword={setShowPassword}
          handlechange={handlechange}
          editIconVisible={editIconVisible}
          showButtons={showButtons}
          setShowButtons={setShowButtons}
          handleSubmit={handleSubmit}
          getProfileDetails={getProfileDetails}
          isTrustee={isTrustee}
        />

        {!isTrustee && (
          <>
            {/* Vertical Border */}
            <div
              style={{
                width: "1px",
                backgroundColor: "#ECECEC",
                margin: "0 2rem",
              }}
            />

            {/* Right Side - Permissions Section */}
            {userRole && (userRole === "financial adviser client" || userRole === "Active financial adviser client")&& (
              <div style={{ flex: 1 }}>
                <PermissionsSection formData={formData} handleSubmit={handleSubmit} handlechange={handlechange} loading={loading} />
              </div>
            )}
          </>
        )}
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};
